export { default } from './Departments';
